import React from "react";

interface Props {
	id: string;
}

function RubricsSvgSelector({ id }: Props) {
	switch (id) {
		case "arrow":
			return (
				<svg
					width="6"
					height="11"
					viewBox="0 0 6 11"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M3.51542 6.06411C3.92396 5.67076 3.92395 5.01674 3.51542 4.62339L0.351746 1.57727C0.112747 1.34715 0.112747 0.964551 0.351746 0.734433C0.578284 0.516313 0.93673 0.516313 1.16327 0.734433L5.2023 4.62339C5.61084 5.01674 5.61084 5.67076 5.2023 6.06411L1.16327 9.95307C0.93673 10.1712 0.578284 10.1712 0.351746 9.95307C0.112747 9.72295 0.112747 9.34034 0.351746 9.11023L3.51542 6.06411Z"
					/>
				</svg>
			);

		case "icon":
			return (
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.983033 16.8412L1.05293 16.7703L0.983034 16.8412L6.67412 22.4475C7.05538 22.8231 7.57435 23.0336 8.11059 23.0336C8.1417 23.0336 8.17279 23.0329 8.20391 23.0315L8.20399 23.0315C8.77298 23.0055 9.30825 22.743 9.67265 22.3106L9.9637 21.9652C9.97462 21.9654 9.98571 21.9653 9.99695 21.9649C9.99702 21.9649 9.99708 21.9649 9.99715 21.9649L19.6164 21.6579C20.2381 22.4056 21.1576 22.8406 22.1523 22.8406C22.5673 22.8406 22.9062 22.5086 22.9062 22.0961V17.051C22.9061 16.6385 22.5673 16.3065 22.1523 16.3065C21.1552 16.3065 20.2344 16.743 19.6128 17.4933L13.8893 17.3066L16.6488 14.0319C16.7042 14.0361 16.7599 14.0382 16.8156 14.0382C17.3808 14.0382 17.9468 13.8262 18.3779 13.4016L18.3077 13.3304L18.3779 13.4016C18.7957 12.99 19.0263 12.4417 19.0263 11.8587C19.0263 11.2758 18.7957 10.7275 18.3779 10.3159L18.3077 10.3871L18.3779 10.3159L17.2862 9.24046C17.2892 9.15169 17.291 9.0625 17.291 8.97416C17.2909 4.48393 13.5833 0.833594 9.02915 0.833594C4.47495 0.833594 0.767426 4.48393 0.767426 8.97421C0.767426 10.4731 1.1796 11.924 1.96293 13.1943L1.12199 13.882C0.683042 14.241 0.415876 14.7691 0.389467 15.3313C0.363057 15.8935 0.579579 16.4438 0.983033 16.8412ZM16.3182 12.3474L16.248 12.4186L16.3182 12.3474L11.407 7.50936C11.2742 7.37851 11.2015 7.20529 11.2015 7.02076C11.2015 6.83623 11.2742 6.66305 11.407 6.53216C11.5438 6.39736 11.7237 6.32966 11.9044 6.32966C12.0851 6.32966 12.265 6.39737 12.4018 6.53215L12.4018 6.53216L17.313 11.3702C17.4458 11.5011 17.5185 11.6743 17.5185 11.8588C17.5185 12.0433 17.4458 12.2165 17.313 12.3474C17.039 12.6174 16.5922 12.6174 16.3182 12.3474ZM8.13438 21.5439L8.13424 21.544C7.98426 21.551 7.84461 21.4974 7.73893 21.3933L7.66874 21.4645L7.73892 21.3933L2.04784 15.7869L1.97766 15.8581L2.04783 15.7869C1.94239 15.683 1.88875 15.5463 1.89564 15.4003L1.89564 15.4003C1.90249 15.2542 1.96874 15.1229 2.08364 15.0289L10.1911 8.39898C10.2383 8.45597 10.2888 8.51094 10.3422 8.56366L10.3423 8.56368L15.2342 13.3828L8.51371 21.358C8.4184 21.4711 8.28429 21.5371 8.13438 21.5439ZM10.3422 5.47793L10.4124 5.54917L10.3422 5.47793C9.96113 5.85335 9.7357 6.34241 9.69905 6.868L3.14008 12.2317C2.57323 11.2405 2.27517 10.1252 2.27517 8.97421C2.27517 5.30804 5.30366 2.32266 9.02915 2.32266C12.2835 2.32266 15.0061 4.6011 15.6424 7.62123L13.4667 5.47793C12.6051 4.62915 11.2039 4.6291 10.3422 5.47793ZM19.9657 18.9947L19.9659 18.9947C20.2363 19.003 20.4911 18.8686 20.6331 18.6399C20.8215 18.3368 21.0881 18.104 21.3984 17.9604L21.3984 21.1866C21.0893 21.0434 20.8234 20.8117 20.6352 20.5102C20.4931 20.2826 20.2383 20.1482 19.9691 20.1568L11.2531 20.435L12.6674 18.7566L19.9657 18.9947Z"
						fill="#939393"
						stroke="#939393"
						stroke-width="0.2"
					/>
				</svg>
			);

		default:
			return <svg></svg>;
	}
}

export default RubricsSvgSelector;
